module.exports = "pegasus/assets/column-18-basic.png";